import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import User from '@/domain/user'
import Openable from '@/global/viewmodels/openable'
import SendMailUserModel from './models/sendMailModel'
import { RoleOuput } from './models/roleOuput'
import { EnumPermission } from '@/domain/permission'
import globalMixin from '../globalMixin'
import { RoleEnum } from '@/domain/role'
import { CommercialSelection } from '@/domain/CommercialSelection'

export default mixins(routeMixin, mobileTypeMixin, globalMixin).extend({
    data: function() {
        return {
            RoleEnum,
            rolesParDefaut: {} as { [role: number]: EnumPermission[] },
            permissions: [] as EnumPermission[],
            roles: [] as RoleOuput[],
            valid: false,
            users: [] as User[],
            commerciauxSelection: [] as CommercialSelection[],
            afficherDesactive: false,
            search: ''
        }
    },
    methods: {
        back() {
            this.navigateToHome()
        },
        deleteUser(user: User) {
            this.$swal.confirm.delete().then(a => {
                if (a.isConfirmed)
                    this.$http
                        .api('user')
                        .deleteWithData(user.id)
                        .then(() => {
                            const dbUser = this.users.find(x => x.id == user.id)
                            if (dbUser) this.users.remove(dbUser)
                        })
                        .catch(x => this.$swal.toast.errorApi(x))
            })
        },
        sauvegarder(user: User, isValid: boolean, dialog: Openable) {
            if (!isValid) return this.$swal.toast.error("Le formulaire n'est pas correctement rempli.")

            if (user.id == 0) {
                this.$http
                    .api('user')
                    .post(user)
                    .then(x => {
                        user.id = x.data
                        dialog.close()
                        this.users.push(user)
                        /**
                         * Envoie du mail de création de mot de passe.
                         */
                        this.$http
                            .api('account/register-mail', true)
                            .post(new SendMailUserModel(user.email, this.baseUrl()))
                            .then(() => {
                                this.$swal.toast.success()
                                this.reload()
                            })
                            .catch(x => this.$swal.toast.errorApi(x))
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
            } else {
                this.$http
                    .api('/user')
                    .put(user)
                    .then(() => {
                        dialog.close()
                        this.$swal.toast.success()
                        this.reload()
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
            }
        },
        filterUsers(value: any, search: string | null, item: User) {
            if (search === null) return true

            search = search.toLowerCase()
            const searchTerms = search.split(' ')
            console.log(searchTerms)

            for (const term of searchTerms) {
                if (item.prenom.toLowerCase().indexOf(term) !== -1) continue
                if (item.nom.toLowerCase().indexOf(term) !== -1) continue
                if (item.email.toLowerCase().indexOf(term) !== -1) continue
                if (item.role.toLowerCase().indexOf(term) !== -1) continue
                if (('orthopédie'.indexOf(term) !== -1 || 'orthopedie'.indexOf(term) !== -1) && item.ortho) continue
                if ('dentaire'.indexOf(term) !== -1 && item.dentaire) continue

                return false
            }

            return true
        },
        reload() {
            this.$http
                .api(`user/all?afficherDesactive=${this.afficherDesactive}`)
                .get()
                .then(x => {
                    this.users = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
        },
        loadArbreRolesPermissions() {
            this.$http
                .api('role/GetArbreRolesPermissions')
                .get()
                .then(x => {
                    this.rolesParDefaut = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
        },
        loadPermissions() {
            this.$http
                .api('role/getallPermissions')
                .get()
                .then(x => {
                    this.permissions = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
        },
        loadRoles() {
            this.$http
                .api('role/getall')
                .get()
                .then(x => {
                    this.roles = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
        },
        loadCommerciaux() {
            this.$http
                .api('user/all-commerciaux')
                .get()
                .then(x => {
                    this.commerciauxSelection = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
        },
        sendMailTelechargementAppInventaire(user: User) {
            this.$swal.confirm.yesCancel('Envoi mail Application Inventaire', "Êtes-vous sûr de vouloir envoyer un mail avec le lien de téléchargement de l'application Biobank Inventaire ?", 'Oui').then(a =>
                a.isConfirmed
                    ? this.$http
                          .api('user/send-invitation-app-inventaire/' + user.id)
                          .put(user.id)
                          .then(x => {
                              this.$swal.toast.success('Le mail a bien été envoyé.')
                          })
                          .catch(x => this.$swal.toast.errorApi(x))
                    : null
            )
        },
        sendMailInscription(user: User) {
            this.$swal.confirm.yesCancel('Envoi mail Inscription', "Êtes-vous sûr de vouloir envoyer un mail avec les informations pour s'inscrire sur le site ?", 'Oui').then(a =>
                a.isConfirmed
                    ? this.$http
                          .api('account/register-mail')
                          .post({ email: user.email, baseUrl: this.baseUrl() })
                          .then(x => {
                              this.$swal.toast.success('Le mail a bien été envoyé.')
                          })
                          .catch(x => {
                              if (x?.response?.data) this.$swal.toast.error(x.response.data)
                              else this.$swal.toast.errorApi(x)
                          })
                    : null
            )
        }
    },
    computed: {
        rolesSelectList: function(): any[] {
            return this.roles.map(x => {
                return { text: x.libelle, value: x.code }
            })
        }
    },
    mounted: function() {
        this.loadRoles()
        this.loadPermissions()
        this.loadArbreRolesPermissions()
        this.reload()
        this.loadCommerciaux()
    },
    watch: {
        afficherDesactive: function() {
            this.reload()
        }
    }
})
